import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExternalServicesService {
  
  private cookieConsentService = inject(NgcCookieConsentService);
  private browserDocument = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  private userConsented = false;

  checkCookieConsent(){
    if (isPlatformBrowser(this.platformId)){
      this.userConsented = this.cookieConsentService.hasConsented();
      return this.userConsented;
    }
    return false;
  }

  initExternalServices(){
    if (this.checkCookieConsent()){
      //initializing GTM which contains the other analytics services
      this.loadGtm();
    }
  }

  private loadGtm(){
    (function(w: any,d: any,s:any,l: any,i: any){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',environment.gtmId);
  }

  private pageChangeGtm(url: string){
    const browserWindow: any = this.browserDocument.defaultView;
    if (browserWindow){
      const dataLayer = browserWindow.dataLayer || [];
      dataLayer.push({
        event: 'pageview',
        page_path: url
      });
    }
  }

  urlChangeEvent(url: string){
    if (this.userConsented && isPlatformBrowser(this.platformId)){
      this.pageChangeGtm(url);
    }
  }
}
